/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var QuoteDocumentType;

(function (QuoteDocumentType) {
  QuoteDocumentType["UNSPECIFIED"] = "unspecified";
  QuoteDocumentType["DETAILS"] = "details";
  QuoteDocumentType["QUOTE"] = "quote";
  QuoteDocumentType["DRAFT"] = "draft";
  QuoteDocumentType["TYPEFORM"] = "typeform";
  QuoteDocumentType["SIGNED"] = "signed";
  QuoteDocumentType["APPLICATION_FORMS"] = "APPLICATION_FORMS";
  QuoteDocumentType["SCH"] = "SCH";
  QuoteDocumentType["QSCH"] = "QSCH";
  QuoteDocumentType["PSCH"] = "PSCH";
  QuoteDocumentType["IPD"] = "IPD";
  QuoteDocumentType["CER"] = "CER";
  QuoteDocumentType["WOR"] = "WOR";
  QuoteDocumentType["SOC"] = "SOC";
  QuoteDocumentType["SOF"] = "SOF";
  QuoteDocumentType["IPID"] = "IPID";
  QuoteDocumentType["PI"] = "PI";
  QuoteDocumentType["LOSS_REPORT"] = "loss_report";
})(QuoteDocumentType || (QuoteDocumentType = {}));